import * as React from "react"
import { connect } from 'react-redux'
import trans from "trans"
import store from "store"

import {
    Theme,
    Icon,
    Grid,
    GridCell,
    FieldLabel,
    css,
    TextInput
} from "@bdfx/mergado-ui-kit"

import { createToast } from "actions";
import { textToast } from "app/helpers/toast_factory";
import Shape, { initTextXmlElementFormatter, RATING_TYPE, TextXmlElementFormatter } from "shape-entities/types/shape"
import { StyledSeparator, StyledToggler } from "./common-shape-form"
import { isJson } from "app/helpers/other"
import { RandomProduct } from "shape-edit/types"
import { AlternativeTemplate, Project, Template } from "app/types/model-types"
import { updateInputValue as change, initForm, selectFormValues } from "app/reducers/form"
import {  getFormName } from "./helpers"
import { TemplateOrAlternativeTemplateType } from "template-edit/undoRedoReducers"


interface Props {
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    updateShapeSizeDebounced: Function
    createToast: typeof createToast
    activeShapeId: string
    randomProduct: RandomProduct
    project: Project
    change: typeof change
}

interface State {
    clipboardText: string
}

class XmlElementFormatterForm extends React.Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            clipboardText: null,
        }
    }

    getInputByType = (fieldType: 'text' | 'number' | 'bool', value: string | number | boolean, field: string, textXmlElementFormatter: TextXmlElementFormatter): JSX.Element => {
        const { activeShapeId, form, isAlt } = this.props
        const formName = getFormName(isAlt)


        switch (fieldType) {
            case 'bool':
                return <StyledToggler
                    value={value}
                    onChange={(val: string) => {
                        let updatedTextXmlElementFormatter: TextXmlElementFormatter = { ...textXmlElementFormatter }
                        updatedTextXmlElementFormatter[field] = val
                        this.props.change(formName, `shapes.${activeShapeId}.text_xml_element_formatter`, JSON.stringify(updatedTextXmlElementFormatter))
                        this.props.updateShapeSizeDebounced(`shapes.${activeShapeId}`, activeShapeId, true)
                    }}
                />
            default:
            case 'text':
            case 'number':
                return <StyledTextInput
                    type={fieldType}
                    value={value}
                    onChange={(val: string) => {
                        let updatedTextXmlElementFormatter: TextXmlElementFormatter = { ...textXmlElementFormatter }
                        updatedTextXmlElementFormatter[field] = val
                        this.props.change(formName, `shapes.${activeShapeId}.text_xml_element_formatter`, JSON.stringify(updatedTextXmlElementFormatter))
                        this.props.updateShapeSizeDebounced(`shapes.${activeShapeId}`, activeShapeId, true)
                    }}
                />
        }
    }

    toggleXMLFormatter = (shape: Shape) => {
        const { activeShapeId, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        if (shape.text_xml_element_formatter) {
            this.props.change(formName, `shapes.${activeShapeId}.text_xml_element_formatter`, null)
        } else {
            this.props.change(formName, `shapes.${activeShapeId}.text_xml_element_formatter`, JSON.stringify(initTextXmlElementFormatter))
        }
    }

    render() {
        const { activeShapeId, form, isAlt } = this.props

        const shape: Shape = form.shapes[activeShapeId]

        if (!shape || !shape.text_fontfamily) {
            return null
        }

        const textXmlElementFormatter: TextXmlElementFormatter = shape.text_xml_element_formatter ? (typeof shape.text_xml_element_formatter === 'string' && isJson(shape.text_xml_element_formatter) ? JSON.parse(shape.text_xml_element_formatter) : (typeof shape.text_xml_element_formatter === 'object' ? shape.text_xml_element_formatter : null)) : null
        const noContent = (!shape.text_content_replaced && !shape.text_content)

        return <React.Fragment>
            {shape.type !== RATING_TYPE &&
                <GridCell><StyledSeparator /></GridCell>
            }

            {shape.type !== RATING_TYPE &&
                <GridCell title={trans('edit_element_content')}>
                    <Grid cols={'auto max-content'} gap={'20px'}>
                        <GridCell onClick={() => this.toggleXMLFormatter(shape)} style={{ alignSelf: 'center', cursor: 'pointer' }}>{trans('edit_element_content')}</GridCell>
                        <GridCell style={{ alignSelf: 'center' }}>
                            <StyledToggler
                                value={shape.text_xml_element_formatter || false}
                                onChange={(value: any) => this.toggleXMLFormatter(shape)}
                            />
                        </GridCell>
                    </Grid>
                </GridCell>
            }

            {textXmlElementFormatter &&
                <React.Fragment>
                    <GridCell style={{ padding: '10px', background: '#eeeeee9c' }}>
                        <Grid gap={'10px'} cols={'min-content auto min-content auto'} style={{ ' .muk-gridcell': { alignSelf: 'center', textAlign: 'right' } }}>
                            <GridCell col='1/-1' style={{ textAlign: 'left !important' }}><FieldLabel>{trans('find_and_replace')}</FieldLabel></GridCell>

                            <GridCell>{`${trans('search')}`.toLowerCase()}</GridCell>
                            <GridCell>{this.getInputByType('text', textXmlElementFormatter['search'], 'search', textXmlElementFormatter)}</GridCell>

                            <GridCell>{trans('replace')}</GridCell>
                            <GridCell>{this.getInputByType('text', textXmlElementFormatter['replace'], 'replace', textXmlElementFormatter)}</GridCell>

                            <GridCell col="span 2">{trans('find_as_regexp')}</GridCell>
                            <GridCell col="span 2">{this.getInputByType('bool', textXmlElementFormatter['is_regexp'], 'is_regexp', textXmlElementFormatter)}</GridCell>

                            <GridCell col='1/-1' style={{ textAlign: 'left !important' }}><FieldLabel>{trans('add_text')}</FieldLabel></GridCell>
                            <GridCell>{trans('prefix')}</GridCell>
                            <GridCell>{this.getInputByType('text', textXmlElementFormatter['prefix'], 'prefix', textXmlElementFormatter)}</GridCell>

                            <GridCell>{trans('suffix')}</GridCell>
                            <GridCell>{this.getInputByType('text', textXmlElementFormatter['suffix'], 'suffix', textXmlElementFormatter)}</GridCell>

                            <GridCell col='1/-1' style={{ textAlign: 'left !important' }}><FieldLabel>{trans('decimal_places')}</FieldLabel></GridCell>
                            <GridCell>{trans('decimals')}</GridCell>
                            <GridCell>{this.getInputByType('number', textXmlElementFormatter['decimals'], 'decimals', textXmlElementFormatter)}</GridCell>

                            <GridCell>{trans('separator')}</GridCell>
                            <GridCell>{this.getInputByType('text', textXmlElementFormatter['decimal_separator'], 'decimal_separator', textXmlElementFormatter)}</GridCell>

                            <GridCell col='1/-1' style={{ textAlign: 'left !important' }}><FieldLabel>{trans('thousands_separation')}</FieldLabel></GridCell>
                            <GridCell>{trans('separator')}</GridCell>
                            <GridCell>{this.getInputByType('text', textXmlElementFormatter['thousands_separator'], 'thousands_separator', textXmlElementFormatter)}</GridCell>

                            <GridCell />
                            <GridCell />
                        </Grid>

                        <SymbolGrid title={trans('copy_to_clipboard')}>
                            <GridCell col={'1/-1'} style={{ marginBottom: '5px', pointerEvents: 'none' }}>
                                <Icon type={'clipboard-copy-radix'} text={trans('symbol_table')} textFirst={false} />
                            </GridCell>

                            {'$€£¥₹₣₱₽₤₦₧₨₩₪₫₼'.split('').map(s => <GridCell key={`symbol${s}`} className={this.state.clipboardText === s ? 'copied' : ''} onClick={() => {
                                navigator.clipboard.writeText(s)
                                this.setState({ clipboardText: s })
                                this.props.createToast(textToast('success', `${trans('copied_to_clipboard')}: ${s}`))
                            }}>{s}</GridCell>)}
                        </SymbolGrid>
                    </GridCell>
                    <GridCell><StyledSeparator /></GridCell>
                </React.Fragment>
            }
        </React.Fragment>
    }
}

const SymbolGrid = css(Grid)({
    padding: '30px 15%',
    gridTemplateColumns: 'repeat(auto-fit, minmax(32px, 1fr))',
    gridColumnGap: '15px',
    gridRowGap: '5px',
    gridAutoFlow: 'row',
    ' .muk-gridcell': {
        alignSelf: 'center',
        textAlign: 'center',
        cursor: 'pointer',
        fontSize: 'large',
        ":hover": {
            background: '#ccc',
        },
    },
    ' .copied': {
        border: '1px solid #ccc',
    }
})

const StyledTextInput = css(TextInput)({
    fontSize: '10px',
    ' input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        ' -webkit-appearance': 'none',
        ' -webkit-box-sizing': 'border-box',
        ' -moz-box-sizing': 'border-box',
        ' box-sizing': 'border-box',
        margin: 0,
        padding: 0,
    },
    ' input[type=number]': {
        ' -moz-appearance': 'textfield',
    },
})


function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        activeShapeId: state.activeShapeId,
        randomProduct: state.randomProduct,
        project: state.project.data,
    }
}

export default connect(mapStateToProps, {
    change,
    initForm,
    createToast,
})(XmlElementFormatterForm)
